import { PartyRelationshipTypeEnum } from '@shared/enums/party-relationship-type.enum';

export class Login {
	accessToken: string;
	isStepupRequired: boolean;
	isReviewRequired: boolean;
	isDeviceKnown: boolean;
	deviceId: string;
	data: LoginData;
}

class LoginData {
	crsFlag: boolean;
	lastSignInDate: string;
	sequenceNumber: string;
	status: string;
	customerDetails: CustomerDetails;
	customerProfiles: CustomerProfileModel[];
}

class CustomerDetails {
	customerFirstName: string;
	customerLastName: string;
	customerName: string;
	mnemonic: string;
	postalCode: string;
	province: string;
}
export interface CustomerProfileModel {
	profileType: ProfileTypeEnum;
	relationship: PartyRelationshipTypeEnum;
	relationshipIndex: number;
}

export enum ProfileTypeEnum {
	RETAIL = 'Retail',
	BUSINESS = 'Business'
}
